<template>
  <div class="comments">
    <transition name="fade">
      <ButtonNew :text="'Escribe un nuevo comentario'" v-if="!showBox"  @change="showCreateBox"/>
    </transition>
    <EmptyState
      v-if="GET_QUESTIONS_COURSE.length === 0 && !showBox"
      :textEmpty="'Se el primero en escribir un comentario'"
      :textDescript="'Toma apuntes mientras vas aprendiendo'"
    ></EmptyState>
    <transition name="fade">
      <NoteCreateBox
        v-if="showBox"
        :disabled="this.GET_LOADDING"
        :showTimer="false"
        @saveNote="saveComment"
        @change="showBox=false"
        :placeholder="'Escribe un comentario ...'"
        :comment="true"
      ></NoteCreateBox>
    </transition>
    <div v-for="data in GET_QUESTIONS_COURSE" :key="data.id">
      <CommentsBox :item="data" @change="showBox=true"></CommentsBox>
    </div>
  </div>
</template>

<script>
import ButtonNew from "../components/ButtonNew.vue";
import EmptyState from "../components/EmptyState.vue";
import CommentsBox from "../components/CommentsBox.vue";
import NoteCreateBox from "../components/NoteCreateBox.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ButtonNew,
    EmptyState,
    CommentsBox,
    NoteCreateBox,
  },
  data() {
    return {
      showBox:false,
    };
  },
  computed: {
    ...mapGetters("questions", ["GET_QUESTIONS_COURSE"]),
    ...mapGetters("questions", ["GET_LOADDING"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods: {
    showCreateBox(){
      this.$store.commit("questions/SET_QUESTION_EDIT", false);
      this.showBox=true
    },
    refresh() {
      let body = {
        mounted_courses_id: this.$route.params.id,
      };
      this.$store.dispatch("questions/get_questions_course", {
        _body: body,
      });
    },
    saveComment(template) {
      let body = {
        question: template,
        mounted_course_id: this.$route.params.id,
        user_id: this.userId.id,
      };

      this.$store.dispatch("questions/post_questions_course", {
        _body: body,
      }).then(() => {
        this.refresh();
      })
    },
  },
  watch:{
    GET_LOADDING(){
      if(!this.GET_LOADDING)
        this.showBox = false         
    }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
